export default __webpack_public_path__ + "static/media/Artboard 9.f3f7908a.png";